module.exports = __webpack_public_path__ + "static/media/Participant Information Statement.fad514a3.txt";